(function () {
  'use strict';

  var root = document.querySelector('[data-scc]');
  var dataNode = document.querySelector('[data-scc-catalog]');
  if (!root || !dataNode) return;

  var catalog;
  try {
    catalog = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  var carScreen = root.querySelector('[data-scc-screen="car"]');
  var versionScreen = root.querySelector('[data-scc-screen="version"]');
  var schemaScreen = root.querySelector('[data-scc-screen="schema"]');
  var generationName = root.querySelector('[data-scc-generation-name]');
  var diagram = root.querySelector('[data-scc-diagram]');
  var zonesHost = root.querySelector('[data-scc-zones]');
  var legend = root.querySelector('[data-scc-legend]');
  var heading = root.querySelector('[data-scc-heading]');
  var description = root.querySelector('[data-scc-description]');
  var architecture = root.querySelector('[data-scc-architecture]');
  var caption = root.querySelector('[data-scc-caption]');
  var results = root.querySelector('[data-scc-results]');
  var resultsTitle = root.querySelector('[data-scc-results-title]');
  var resultsDescription = root.querySelector('[data-scc-results-description]');
  var filters = root.querySelector('[data-scc-filters]');
  var count = root.querySelector('[data-scc-count]');
  var productsHost = root.querySelector('[data-scc-products]');
  var state = { generation: '', carId: '', zone: null, filter: 'all', products: [] };
  var productCache = new Map();
  var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  // === GA4 tracking ===
  // Mêmes noms d'events que le configurateur guidé (exhaust-selector.js), distingués
  // par le param `flow: 'classic'`. Jamais de param nommé source/medium/campaign :
  // GA4 les lit comme une source de trafic (cf. theme/CLAUDE.md, section GA4).
  var entryPath = (function () {
    try {
      var url = new URL(window.location.href);
      var from = url.searchParams.get('cfg_from');
      if (from) return from;
      var ref = document.referrer || '';
      if (!ref) return 'direct';
      if (ref.indexOf('/collections/') !== -1) return 'collection';
      if (ref.indexOf('/products/') !== -1) return 'pdp';
      if (ref.indexOf('/pages/notre-gamme') !== -1) return 'notre_gamme';
      if (ref.indexOf('/pages/sound-library') !== -1) return 'sound_library';
      if (ref.indexOf('/search') !== -1) return 'search';
      var u = new URL(ref);
      if (u.host === window.location.host && (u.pathname === '/' || /^\/(en|fr|de|es|it|pt)([-/]|$)/.test(u.pathname))) return 'homepage';
      return 'other';
    } catch (error) { return 'direct'; }
  })();

  function track(name, params) {
    var payload = { flow: 'classic', entry_path: entryPath };
    if (params && params.value !== undefined) params.choice = params.value;
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value === undefined || value === null || value === '') return;
      payload[key] = value;
    });
    // gtag (canal Google Shopify) se charge après ce script : réessai jusqu'à 10 s pour le start.
    var send = function (tries) {
      if (typeof window.gtag === 'function') { try { window.gtag('event', name, payload); } catch (error) {} return; }
      if (tries > 0) setTimeout(function () { send(tries - 1); }, 250);
    };
    send(40);
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (error) {}
  }

  function context() {
    return {
      generation: state.generation,
      car: state.carId,
      zone: state.zone ? state.zone.id : '',
      filter: state.zone && state.zone.filter ? state.filter : ''
    };
  }

  function text(name) {
    return root.dataset[name] || '';
  }

  function setQueryCar(carId) {
    var url = new URL(window.location.href);
    if (carId) url.searchParams.set('car', carId);
    else url.searchParams.delete('car');
    window.history.replaceState({}, '', url.toString());
  }

  function showGenerations(focus) {
    state.generation = '';
    state.carId = '';
    state.zone = null;
    carScreen.hidden = false;
    versionScreen.hidden = true;
    schemaScreen.hidden = true;
    results.hidden = true;
    root.classList.remove('is-version', 'is-schema');
    setQueryCar('');
    if (focus) root.querySelector('[data-scc-generation]').focus({ preventScroll: true });
  }

  function showVersions(generationId, options) {
    var generationButton = root.querySelector('[data-scc-generation="' + generationId + '"]');
    var versionGroup = root.querySelector('[data-scc-versions="' + generationId + '"]');
    if (!generationButton || !versionGroup) return;

    state.generation = generationId;
    state.carId = '';
    state.zone = null;
    carScreen.hidden = true;
    versionScreen.hidden = false;
    schemaScreen.hidden = true;
    results.hidden = true;
    root.classList.add('is-version');
    root.classList.remove('is-schema');
    generationName.textContent = generationButton.dataset.label;
    root.querySelectorAll('[data-scc-versions]').forEach(function (group) {
      group.hidden = group !== versionGroup;
    });
    setQueryCar('');

    if (options && options.focus) versionGroup.querySelector('[data-scc-car]').focus({ preventScroll: true });
  }

  function createImage(car) {
    diagram.replaceChildren();
    if (car.image) {
      var image = document.createElement('img');
      image.src = car.image;
      image.alt = car.alt || '';
      image.width = 1800;
      image.height = 1200;
      diagram.appendChild(image);
      return;
    }

    var template = root.querySelector('[data-scc-svg="' + car.diagram + '"]');
    if (template) diagram.appendChild(template.content.cloneNode(true));
  }

  function linkedElements(zoneId) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-scc-zone="' + zoneId + '"]'));
  }

  function setHot(zoneId, hot) {
    linkedElements(zoneId).forEach(function (element) {
      element.classList.toggle('is-hot', hot);
    });
  }

  function createZoneButtons(car) {
    zonesHost.replaceChildren();
    legend.replaceChildren();

    car.zones.forEach(function (zone, zoneIndex) {
      zone.rects.forEach(function (rect) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'scc__zone';
        button.dataset.sccZone = zone.id;
        button.dataset.index = String(zoneIndex + 1);
        button.setAttribute('aria-label', zone.n);
        button.style.setProperty('--left', rect[0] + '%');
        button.style.setProperty('--top', rect[1] + '%');
        button.style.setProperty('--width', rect[2] + '%');
        button.style.setProperty('--height', rect[3] + '%');
        button.addEventListener('mouseenter', function () { setHot(zone.id, true); });
        button.addEventListener('mouseleave', function () { setHot(zone.id, false); });
        button.addEventListener('focus', function () { setHot(zone.id, true); });
        button.addEventListener('blur', function () { setHot(zone.id, false); });
        button.addEventListener('click', function () { selectZone(zone); });
        zonesHost.appendChild(button);
      });

      var card = document.createElement('button');
      var copy = document.createElement('span');
      var title = document.createElement('strong');
      var detail = document.createElement('small');
      var arrow = document.createElement('i');
      card.type = 'button';
      card.className = 'scc__legend-card';
      card.dataset.sccZone = zone.id;
      title.textContent = zone.n;
      detail.textContent = zone.d;
      copy.appendChild(title);
      copy.appendChild(detail);
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '›';
      card.appendChild(copy);
      card.appendChild(arrow);
      card.addEventListener('mouseenter', function () { setHot(zone.id, true); });
      card.addEventListener('mouseleave', function () { setHot(zone.id, false); });
      card.addEventListener('focus', function () { setHot(zone.id, true); });
      card.addEventListener('blur', function () { setHot(zone.id, false); });
      card.addEventListener('click', function () { selectZone(zone); });
      legend.appendChild(card);
    });
  }

  function showCar(carId, options) {
    var car = catalog[carId];
    if (!car) return;
    var versionButton = root.querySelector('[data-scc-car="' + carId + '"]');
    if (versionButton) state.generation = versionButton.dataset.sccGenerationId;
    state.carId = carId;
    state.zone = null;
    state.filter = 'all';
    carScreen.hidden = true;
    versionScreen.hidden = true;
    schemaScreen.hidden = false;
    results.hidden = true;
    root.classList.remove('is-version');
    root.classList.add('is-schema');
    heading.textContent = car.name;
    description.textContent = car.description;
    architecture.textContent = car.architecture;
    caption.textContent = car.caption;
    createImage(car);
    createZoneButtons(car);
    setQueryCar(carId);
  }

  function normalizeProduct(item) {
    return typeof item === 'string' ? { h: item, f: [] } : item;
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    var promise = fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product ' + handle + ': ' + response.status);
      return response.json();
    }).catch(function () {
      return null;
    });
    productCache.set(handle, promise);
    return promise;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var locale = document.documentElement.lang || 'fr-FR';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return amount.toFixed(0) + ' ' + currency;
    }
  }

  function productImage(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

  function trackProductClick(link, entry, slot, position) {
    link.addEventListener('click', function () {
      track('configurator_product_click', Object.assign({
        product_handle: entry.config.h,
        product_title: entry.product.title,
        product_label: entry.config.l || '',
        slot: slot,
        position: position || 0,
        available: entry.product.available ? 'yes' : 'no'
      }, context()));
    });
  }

  function createProductCard(entry, slot, position) {
    var product = entry.product;
    var link = document.createElement('a');
    var media = document.createElement('div');
    var copy = document.createElement('div');
    var title = document.createElement('strong');
    var meta = document.createElement('div');
    var price = document.createElement('b');
    var availability = document.createElement('span');
    var imageUrl = productImage(product);

    link.className = 'scc__product';
    link.href = rootPath + 'products/' + entry.config.h;
    media.className = 'scc__product-media';
    copy.className = 'scc__product-copy';
    meta.className = 'scc__product-meta';
    title.textContent = product.title;
    price.textContent = formatMoney(product.price);
    availability.textContent = product.available ? '' : text('unavailable');

    if (!product.available) link.classList.add('is-unavailable');

    if (imageUrl) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 500;
      image.height = 350;
      media.appendChild(image);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'scc__product-placeholder';
      placeholder.textContent = 'SCART';
      media.appendChild(placeholder);
    }

    copy.appendChild(title);
    meta.appendChild(price);
    meta.appendChild(availability);
    link.appendChild(media);
    link.appendChild(copy);
    link.appendChild(meta);
    trackProductClick(link, entry, slot || 'list', position);
    return link;
  }

  function createSoundCard(entry, position) {
    var product = entry.product;
    var link = document.createElement('a');
    var media = document.createElement('span');
    var name = document.createElement('strong');
    var title = document.createElement('small');
    var price = document.createElement('b');
    var imageUrl = productImage(product);

    link.className = 'scc__sound-product';
    link.href = rootPath + 'products/' + entry.config.h;
    media.className = 'scc__sound-product-media';
    name.textContent = entry.config.l || product.title;
    title.textContent = entry.config.d || product.title;
    price.textContent = formatMoney(product.price);

    if (!product.available) link.classList.add('is-unavailable');
    if (imageUrl) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 500;
      image.height = 350;
      media.appendChild(image);
    }

    link.appendChild(media);
    link.appendChild(name);
    link.appendChild(title);
    link.appendChild(price);
    trackProductClick(link, entry, 'sound', position);
    return link;
  }

  function rangeText(key, suffix) {
    var name = 'range' + key.charAt(0).toUpperCase() + key.slice(1) + (suffix || '');
    return text(name);
  }

  function createRangeCard(entry, position) {
    var product = entry.product;
    var key = entry.config.r;
    var link = document.createElement('a');
    var media = document.createElement('span');
    var name = document.createElement('span');
    var description = document.createElement('span');
    var price = document.createElement('span');
    var imageUrl = productImage(product);

    link.className = 'scc__range-product scc__range-product--' + key;
    link.href = rootPath + 'products/' + entry.config.h;
    media.className = 'scc__range-media';
    name.className = 'scc__range-name';
    name.textContent = entry.config.l || rangeText(key);
    description.className = 'scc__range-copy';
    description.textContent = entry.config.d || rangeText(key, 'Copy');
    price.className = 'scc__range-price';
    price.textContent = formatMoney(product.price);
    link.setAttribute('aria-label', product.title + ' - ' + price.textContent);

    if (!product.available) link.classList.add('is-unavailable');

    if (imageUrl) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 500;
      image.height = 350;
      media.appendChild(image);
    }

    link.appendChild(media);
    link.appendChild(name);
    link.appendChild(description);
    link.appendChild(price);
    trackProductClick(link, entry, 'range', position);
    return link;
  }

  function renderProductRange(entries) {
    var order = { standard: 1, sport: 2, racing: 3 };
    var journey = document.createElement('div');
    var scale = document.createElement('p');
    var row = document.createElement('div');
    var warning = document.createElement('p');
    var scaleLabels = state.zone && state.zone.scale
      ? state.zone.scale
      : [text('rangeFrom'), text('rangeTo')];
    var sorted = entries.slice().sort(function (left, right) {
      return Number(left.config.s || order[left.config.r] || 0) - Number(right.config.s || order[right.config.r] || 0);
    });

    productsHost.classList.add('has-product-range');
    journey.className = 'scc__range-journey';
    scale.className = 'scc__range-scale';
    scale.setAttribute('aria-hidden', 'true');
    row.className = 'scc__range-row';
    sorted.forEach(function (entry, index) {
      row.appendChild(createRangeCard(entry, index + 1));
    });
    scaleLabels.forEach(function (label, index) {
      var marker = document.createElement('span');
      marker.textContent = label;
      scale.appendChild(marker);
      if (index < scaleLabels.length - 1) scale.appendChild(document.createElement('i'));
    });
    journey.appendChild(row);
    journey.appendChild(scale);
    var warningText = state.zone && state.zone.warning ? state.zone.warning : '';
    if (!warningText && sorted.some(function (entry) { return entry.config.r === 'racing'; })) {
      warningText = rangeText('racing') + ' : ' + text('rangeWarning');
    }
    if (warningText) {
      warning.className = 'scc__range-warning';
      warning.textContent = warningText;
      journey.appendChild(warning);
    }
    productsHost.appendChild(journey);
  }

  function appendAlternativeGroup(entries, label, slot) {
    if (!entries.length) return;
    var group = document.createElement('section');
    var heading = document.createElement('h4');
    var grid = document.createElement('div');
    group.className = 'scc__alternatives';
    heading.textContent = label;
    grid.className = 'scc__alternatives-grid';
    entries.forEach(function (entry, index) {
      grid.appendChild(createProductCard(entry, slot || 'alternative', index + 1));
    });
    if (label) group.appendChild(heading);
    group.appendChild(grid);
    productsHost.appendChild(group);
  }

  function renderSoundProducts(visible) {
    var soundEntries = visible.filter(function (entry) {
      return entry.config.g === 'sound';
    }).sort(function (left, right) {
      return Number(left.config.s || 0) - Number(right.config.s || 0);
    });
    var catalystEntries = visible.filter(function (entry) { return entry.config.g === 'catalyst'; });
    var valveEntries = visible.filter(function (entry) { return entry.config.g === 'valve'; });
    var otherEntries = visible.filter(function (entry) { return !entry.config.g; });
    var journey = document.createElement('div');
    var row = document.createElement('div');
    var scale = document.createElement('p');
    var quiet = document.createElement('span');
    var line = document.createElement('i');
    var loud = document.createElement('span');

    productsHost.classList.add('has-sound-scale');
    journey.className = 'scc__sound-journey';
    row.className = 'scc__sound-row';
    scale.className = 'scc__sound-scale';
    scale.setAttribute('aria-hidden', 'true');
    quiet.textContent = state.zone && state.zone.scale ? state.zone.scale[0] : text('quiet');
    loud.textContent = state.zone && state.zone.scale ? state.zone.scale[1] : text('loud');
    soundEntries.forEach(function (entry, index) { row.appendChild(createSoundCard(entry, index + 1)); });
    scale.appendChild(quiet);
    scale.appendChild(line);
    scale.appendChild(loud);
    journey.appendChild(row);
    journey.appendChild(scale);
    productsHost.appendChild(journey);
    appendAlternativeGroup(catalystEntries, text('withCatalyst'), 'catalyst');
    appendAlternativeGroup(valveEntries, text('withValves'), 'valve');
    appendAlternativeGroup(otherEntries, '', 'alternative');
  }

  function matchesFilter(entry) {
    if (!state.filter) return false;
    if (state.filter === 'all') return true;
    var values = entry.config.f || [];
    return values.indexOf(state.filter) !== -1;
  }

  function renderProducts() {
    productsHost.replaceChildren();
    productsHost.classList.remove('has-sound-scale', 'has-product-range');
    if (state.zone && state.zone.filter && !state.filter) {
      count.textContent = text('chooseFilter');
      return;
    }
    var visible = state.products.filter(function (entry) {
      return entry.product && matchesFilter(entry);
    });

    count.textContent = visible.length + ' ' + (visible.length === 1 ? text('product') : text('products'));
    var hasSoundScale = visible.filter(function (entry) {
      return entry.config.g === 'sound';
    }).length > 1;
    var hasProductRange = !hasSoundScale && visible.length > 1 && visible.every(function (entry) {
      return Boolean(entry.config.r);
    });
    var render = !visible.length ? 'empty' : hasSoundScale ? 'sound_scale' : hasProductRange ? 'range' : 'list';
    track('configurator_result', Object.assign({
      has_match: visible.length > 0,
      match_count: visible.length,
      render: render,
      top_product_handle: visible.length ? visible[0].config.h : ''
    }, context()));

    if (!visible.length) {
      var empty = document.createElement('p');
      empty.className = 'scc__empty';
      empty.textContent = text('noProducts');
      productsHost.appendChild(empty);
      return;
    }
    if (hasSoundScale) {
      renderSoundProducts(visible);
      return;
    }
    if (hasProductRange) {
      renderProductRange(visible);
      return;
    }
    visible.forEach(function (entry, index) {
      productsHost.appendChild(createProductCard(entry, 'list', index + 1));
    });
  }

  function renderFilter(zone) {
    filters.replaceChildren();
    if (!zone.filter) return;

    var label = document.createElement('p');
    var options = document.createElement('div');
    label.className = 'scc__filter-label';
    label.textContent = zone.filter.label;
    options.className = 'scc__filter-options';

    zone.filter.options.filter(function (option) {
      return option.id !== 'all';
    }).forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'scc__filter';
      button.textContent = option.l;
      button.classList.toggle('is-selected', option.id === state.filter);
      button.setAttribute('aria-pressed', option.id === state.filter ? 'true' : 'false');
      button.addEventListener('click', function () {
        state.filter = option.id;
        track('configurator_select', Object.assign({ step: 'filter', value: option.id }, context()));
        options.querySelectorAll('.scc__filter').forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        renderProducts();
      });
      options.appendChild(button);
    });

    filters.appendChild(label);
    filters.appendChild(options);
  }

  function selectZone(zone) {
    state.zone = zone;
    state.filter = zone.filter ? '' : 'all';
    state.products = [];
    track('configurator_select', { step: 'zone', value: zone.id, generation: state.generation, car: state.carId, zone: zone.id, needs_filter: zone.filter ? 'yes' : 'no' });
    linkedElements(zone.id).forEach(function (element) {
      element.classList.remove('is-hot');
    });
    root.querySelectorAll('[data-scc-zone]').forEach(function (element) {
      element.classList.toggle('is-selected', element.dataset.sccZone === zone.id);
    });

    resultsTitle.textContent = zone.n;
    resultsDescription.textContent = zone.d;
    results.hidden = false;
    renderFilter(zone);
    count.textContent = '';
    productsHost.replaceChildren();
    count.textContent = zone.filter ? text('chooseFilter') : text('loading');
    root.setAttribute('aria-busy', 'true');

    var configs = zone.products.map(normalizeProduct);
    Promise.all(configs.map(function (config) {
      return fetchProduct(config.h).then(function (product) {
        return { config: config, product: product };
      });
    })).then(function (loaded) {
      if (state.zone !== zone) return;
      state.products = loaded;
      root.removeAttribute('aria-busy');
      renderProducts();
    });

    window.requestAnimationFrame(function () {
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  root.querySelectorAll('[data-scc-generation]').forEach(function (button) {
    button.addEventListener('click', function () {
      showVersions(button.dataset.sccGeneration);
      track('configurator_select', { step: 'generation', value: button.dataset.sccGeneration, generation: button.dataset.sccGeneration });
    });
  });

  root.querySelectorAll('[data-scc-car]').forEach(function (button) {
    button.addEventListener('click', function () {
      showCar(button.dataset.sccCar);
      track('configurator_select', { step: 'version', value: button.dataset.sccCar, generation: state.generation, car: state.carId });
    });
  });

  root.querySelector('[data-scc-back-generation]').addEventListener('click', function () {
    track('configurator_restart', { from_step: 'version', generation: state.generation });
    showGenerations(true);
  });

  root.querySelector('[data-scc-back]').addEventListener('click', function () {
    track('configurator_back', Object.assign({ from_step: 'schema', to_step: 'version' }, context()));
    showVersions(state.generation, { focus: true });
  });

  root.querySelector('[data-scc-close-results]').addEventListener('click', function () {
    track('configurator_back', Object.assign({ from_step: 'results', to_step: 'schema' }, context()));
    state.zone = null;
    results.hidden = true;
    root.querySelectorAll('[data-scc-zone]').forEach(function (element) {
      element.classList.remove('is-selected');
    });
  });

  var initialCar = new URL(window.location.href).searchParams.get('car');
  if (initialCar && catalog[initialCar]) showCar(initialCar, { silent: true });
  track('configurator_start', { prefill: initialCar && catalog[initialCar] ? 'car' : 'none', car: state.carId, generation: state.generation });
  if (initialCar && catalog[initialCar]) track('configurator_prefill', { from: initialCar, car: state.carId, generation: state.generation });
})();
